// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"474":"4090afd0","554":"b41c754d","871":"dc50d735"}[chunkId] + ".chunk.css";
};